import React from "react";

import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";


import facial1 from "./facial1.jpg";
import facial2 from "./facial2.jpg";
import facial3 from "./facial3.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

export default function ProductDetailPage() {
    

    // ⭐ Add this function at the top (inside the component)
    const renderStars = (rating) => {
        const fullStars = Math.floor(rating);
        const halfStar = rating % 1 >= 0.5;
        const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

        const stars = [];

        for (let i = 0; i < fullStars; i++) {
            stars.push(<FaStar key={`full-${i}`} className="text-warning" />);
        }

        if (halfStar) {
            stars.push(<FaStarHalfAlt key="half" className="text-warning" />);
        }

        for (let i = 0; i < emptyStars; i++) {
            stars.push(<FaRegStar key={`empty-${i}`} className="text-warning" />);
        }

        return <div className="d-flex justify-content-center gap-1 mb-2">{stars}</div>;
    };


    const similarProducts = [
        { name: "Glow Facial", price: "₹499", image: facial2, rating: 4.5 },
        { name: "Brightening Facial", price: "₹399", image: facial3, rating: 4.0 },
    ];


    const addOns = [
        { name: "Half leg wax", price: "₹199", image: facial1, rating: 4.0 },
        { name: "upper lip threading", price: "₹149", image: facial2, rating: 3.5 },
        { name: "arm wax", price: "₹99", image: facial3, rating: 3.0 },
        { name: "Hair Spa", price: "₹299", image: facial1, rating: 4.5 },
        { name: "manicure", price: "₹249", image: facial2, rating: 5.0 },
    ];
    const customerFeedbacks = [
        { name: "Aditi Sharma", feedback: "Amazing service! So polite and punctual. Loved the facial!", rating: 5 },
        { name: "Neha Verma", feedback: "Great experience. The waxing was clean and quick. Will book again!", rating: 4.5 },
        { name: "Riya Malhotra", feedback: "Affordable and professional. Booked a spa session and felt relaxed.", rating: 4 },
    ];


    return (
        <div style={{ backgroundColor: "#f7ead7", paddingBottom: "100px" }}>
             <Header />

            {/* Navbar */}
            <Navbar />

            {/* Hero Section */}
            {/* Carousel */}
            <div className="container py-4">
                <div id="facialCarousel" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner rounded-4 shadow-sm overflow-hidden">
                        {[facial1, facial2, facial3].map((img, idx) => (
                            <div className={`carousel-item ${idx === 0 ? "active" : ""}`} key={idx}>
                                <img src={img} alt="service banner" className="d-block w-100" style={{ maxHeight: "400px", objectFit: "cover" }} />
                            </div>
                        ))}
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#facialCarousel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" />
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#facialCarousel" data-bs-slide="next">
                        <span className="carousel-control-next-icon" />
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>

            {/* Service Details */}
            <main className="container pb-4">
                <div className="bg-white p-4 rounded-4 shadow-sm">
                    <h5 className="fw-bold text-dark mb-1">Three Star Facial</h5>
                    {renderStars(4.0)}

                    <ul className="text-dark mb-3 ps-3">
                        <li>Cleansing with herbal cleanser</li>
                        <li>Gentle exfoliation scrub</li>
                        <li>Basic hydration mask</li>
                        <li>Soft tissue massage</li>
                        <li>Organic toner finish</li>
                    </ul>
                    <div className="text-center">
                        <h4 className="fw-bold text-dark mb-3">₹299</h4>
                        <button className="btn custom-btn uniform-btn me-2">Add to Cart</button>
                        <button className="btn custom-btn uniform-btn">Book Now</button>
                    </div>
                </div>
            </main>
            {/* Customer Feedback Section */}
            <section className="container mb-5">
                <h4 className="fw-bold mb-4 text-center">What Our Customers Say</h4>

                {/* Scrollable Feedback Cards */}
                <div className="feedback-scroll d-flex overflow-auto gap-4 pb-2 px-2">
                    {customerFeedbacks.map((item, idx) => (
                        <div
                            key={idx}
                            className="card flex-shrink-0 rounded-4 shadow-sm border-0 p-3"
                            style={{
                                width: "250px",       // 👈 You can adjust width
                                height: "120px",      // 👈 You can adjust height
                                backgroundColor: "white",
                            }}
                        >
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <strong className="text-dark">{item.name}</strong>
                                {renderStars(item.rating)}
                            </div>

                            <p className="text-secondary" style={{ fontStyle: "italic", fontSize: "0.9rem" }}>
                                <i className="bi bi-quote text-muted me-1" />
                                {item.feedback}
                            </p>
                        </div>
                    ))}
                </div>
            </section>



            {/* Similar Products */}
            <section className="container mb-5">
                <h4 className="fw-bold mb-3 text-center">Similar Products</h4>
                <div className="d-flex overflow-auto gap-4 pb-2">
                    {similarProducts.map((item, idx) => (
                        <div key={idx} className="card flex-shrink-0 rounded-4 shadow-sm border-0 zoom-card" style={{ width: "300px" }}>
                            <img src={item.image} alt="service banner" className="card-img-top rounded-top-4" style={{ height: "160px", objectFit: "cover" }} />
                            <div className="card-body text-center">
                                <h6 className="fw-bold mb-1">{item.name}</h6>
                                {renderStars(item.rating)}

                                <p className="text-muted">{item.price}</p>
                                <div className="d-flex justify-content-center gap-2">
                                    <button className="btn btn-sm btn-outline-primary">View Details</button>
                                    <button className="btn btn-sm custom-btn">Book Now</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>


            {/* Add-ons */}
            <section className="container mb-5">
                <h4 className="fw-bold mb-3 text-center">Add-ons</h4>
                <div className="d-flex overflow-auto gap-4 pb-2">
                    {addOns.map((item, idx) => (
                        <div key={idx} className="card flex-shrink-0 rounded-4 shadow-sm border-0 zoom-card" style={{ width: "220px" }}>
                            <img src={item.image} alt="service banner" className="card-img-top rounded-top-4" style={{ height: "160px", objectFit: "cover" }} />
                            <div className="card-body text-center">
                                <h6 className="fw-bold mb-1">{item.name}</h6>
                                {renderStars(item.rating)}

                                <p className="text-muted">{item.price}</p>
                                <div className="d-flex justify-content-center gap-2">
                                    <button className="btn btn-sm btn-outline-primary">View Details</button>
                                    <button className="btn btn-sm custom-btn">Add to Cart</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>


            {/* Bottom Fixed Navbar */}
            <nav
                className="bg-white shadow-lg border-top d-flex justify-content-around align-items-center py-2 px-3"
                style={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    zIndex: 1050,
                }}
            >
                <button className="btn btn-outline-dark px-4 fw-semibold">Add to Cart</button>
                <button className="btn btn-success px-4 fw-semibold">Book Now</button>
                <button className="btn btn-primary px-4 fw-semibold">View Cart</button>
            </nav>

            {/* Footer */}
            <Footer />
            {/* Styles */}
            <style jsx="true">{`
        .custom-btn {
          background-color: #466346;
          color: white;
          border: none;
          border-radius: 50px;
          transition: all 0.3s ease;
        }
        .custom-btn:hover {
          background-color: #a777e3 !important;
          color: white !important;
        }
        .uniform-btn {
          min-width: 160px;
          padding: 10px 0;
        }
        
        .zoom-card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .zoom-card:hover {
             transform: scale(1.05);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
            zindex: 2;
        }
        .text-warning {
            font-size: 1rem;
            line-height: 1;
        }
        .card p {
            font-size: 0.95rem;
            line-height: 1.4;
        }
            .feedback-scroll::-webkit-scrollbar {
  height: 8px;
}
.feedback-scroll::-webkit-scrollbar-thumb {
  background-color: #a777e3;
  border-radius: 10px;
}
.feedback-scroll::-webkit-scrollbar-track {
  background: transparent;
}



      `}</style>
        </div>
    );
}
